import axios from "axios";
import {
  Button,
  IconButton,
  Typography
} from "@mui/material";
import styles from "./style.module.css";
import SearchIcon from "@mui/icons-material/Search";
import React, { useState, useEffect, useContext } from "react";
import styled from "styled-components";
import Box from "@mui/material/Box";
import {
  GridColDef,
  GridToolbarContainer,
  GridToolbarExport,
} from "@mui/x-data-grid";
import CircularModal from '../../custom/circularModalLoader/circularModalLoader';
import ReportsTable from '../../custom/reportsTable';
// import { errorToast, pvcStockInDetails } from "../../../../utils/constants";
import {
  CalendarIcon,
  LocalizationProvider,
  MobileDatePicker,
} from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment, { MomentInput } from "moment";
import { pvcStockInDetails, pvcStockOutOrderDetails } from "../../../utils/constant";
import Title from "../../custom/Title";
import { getStockInReport, getStockOutReport } from "../../../services/Reports";
import useService from "../../../hooks/useService";
import { AuthContext } from "../../../contexts/AuthContext";



const DataGridContainer = styled.div`
  height: calc(100%);
  overflow-x: auto;
`;
export const StockOutReport = () => {
  let sessionId: any = localStorage.getItem("sessionId");
  const [loading, setLoading] = useState(false);
  const [pvcStockOutOrders, setPvcStockOutOrders] = useState<any>([]);
  const [fromDate, setFromDate] = useState<any>(new Date().toString());
  const [toDate, setToDate] = useState<any>(new Date().toString());
  const [destinationOptions, setDestinationOptions] = useState<any>([]);
  const { execute } = useService();
  const { user: { centerId }, pvcAddresses } = useContext(AuthContext)



  const getDestination = async () => {
    try {
      setLoading(true);
      const params = { sessionid: sessionId };
      const response = await axios.post(
        "/api/commerce/inventoryManagement/fetchBusinessUnits",
        params
      );
      setLoading(false);
      setDestinationOptions(response?.data);
    } catch (error) {
      setLoading(false);
      console.error(error);
    //   errorToast("Unable to get destinations!");
    }
  };

  const checkDateDifference = (fromDate: Date, toDate: Date) => {
    const fromDateObj = new Date(fromDate);
    const toDateObj = new Date(toDate);
    const differenceInTime = toDateObj.getTime() - fromDateObj.getTime();
    const differenceInDays = differenceInTime / (1000 * 3600 * 24);

    if (differenceInDays > 30) return true;
    else return false;
  };

  const getPvcStockInData = async () => {
    try {
      let dateRange = checkDateDifference(fromDate, toDate);
      if (dateRange) return alert("Date range should be less than 30 days!");

      let centerIds = centerId

      setLoading(true);
      const params = {
        centerIds,
        fromDate,
        toDate,
      };

    //   const response = await axios.post(
    //     "/api/pvcReports/getStockInReport",
    //     params
    //   );
      const { data } = await execute(() => getStockOutReport({params}))

      setLoading(false);
      setPvcStockOutOrders(data?.data || []);
    } catch (error) {
      setLoading(false);
      console.error(error);
      alert("Unable to get pvc stock-out orders!");
    }
  };

  const getPvcStockDataColumns = () => {
    let minWidth = 100;

    return pvcStockOutOrderDetails.map((inboundField: any) => {
      const row: GridColDef = {
        field: inboundField.id,
        headerName: inboundField.label,
        minWidth,
        align: "left",
      };

      switch (inboundField.id) {
        case "skuId":
          row.minWidth = 200;
          row.renderCell = (params) => {
            return params.row.skuId ? params.row.skuId : "N/A";
          };
          break;
        case "destination":
          row.minWidth = 220;
          row.renderCell = (params) => {
            return params.row.destination ? params.row.destination : "N/A";
          };
          break;
        case "customerGstIn":
          row.minWidth = 220;
          row.renderCell = (params) => {
            return params.row.customerGstIn ? params.row.customerGstIn : "N/A";
          };
          break;
        case "customerDeliveryLocation":
          row.minWidth = 250;
          row.renderCell = (params) => {
            return params.row.customerDeliveryLocation
              ? params.row.customerDeliveryLocation
              : "N/A";
          };
          break;
        case "customerDeliveryLocation":
          row.minWidth = 250;
          row.renderCell = (params) => {
            return params.row.customerDeliveryLocation
              ? params.row.customerDeliveryLocation
              : "N/A";
          };
          break;
        case "customerDeliveyCity":
          row.minWidth = 250;
          row.renderCell = (params) => {
            return params.row.customerDeliveyCity
              ? params.row.customerDeliveyCity
              : "N/A";
          };
          break;
        case "customerDeliveryState":
          row.minWidth = 250;
          row.renderCell = (params) => {
            return params.row.customerDeliveryState
              ? params.row.customerDeliveryState
              : "N/A";
          };
          break;
        case "supplierDeliveyCity":
          row.minWidth = 250;
          row.renderCell = (params) => {
            return params.row.supplierDeliveyCity
              ? params.row.supplierDeliveyCity
              : "N/A";
          };
          break;
        case "supplierDeliveryState":
          row.minWidth = 250;
          row.renderCell = (params) => {
            return params.row.supplierDeliveryState
              ? params.row.supplierDeliveryState
              : "N/A";
          };
          break;
        case "supplierGstIn":
          row.minWidth = 250;
          row.renderCell = (params) => {
            return params.row.supplierGstIn ? params.row.supplierGstIn : "N/A";
          };
          break;
        case "supplierGstIn":
          row.minWidth = 250;
          row.renderCell = (params) => {
            return params.row.supplierGstIn ? params.row.supplierGstIn : "N/A";
          };
          break;
        case "metal":
          row.minWidth = 120;
          row.renderCell = (params) => {
            return params.row.metal ? params.row.metal : "N/A";
          };
          break;
        case "purity":
          row.minWidth = 120;
          row.renderCell = (params) => {
            return params.row.purity ? params.row.purity : "N/A";
          };
          break;
        case "quantity":
          row.minWidth = 120;
          row.renderCell = (params) => {
            return params.row.quantity ?? 0;
          };
          break;
        case "weight":
          row.minWidth = 150;
          row.renderCell = (params) => {
            return params.row.weight ?? 0;
          };
          break;
        case "fineWeight":
          row.minWidth = 150;
          row.renderCell = (params) => {
            return params.row.fineWeight ?? 0;
          };
          break;
        case "dimensions":
          row.minWidth = 100;
          row.renderCell = (params) => {
            return params.row.dimensions ? params.row.dimensions : "N/A";
          };
          break;
        case "totalRate":
          row.minWidth = 200;
          row.renderCell = (params) => {
            return params.row.totalRate ?? 0;
          };
          break;
        case "shipper":
          row.minWidth = 400;
          row.renderCell = (params) => {
            return params.row.shipper ? params.row.shipper : "N/A";
          };
          break;
        case "destination":
          row.minWidth = 400;
          row.renderCell = (params) => {
            return params.row.destination ? params.row.destination : "N/A";
          };
          break;
        case "productName":
          row.minWidth = 250;
          row.renderCell = (params) => {
            return params.row.productName ? params.row.productName : "N/A";
          };
          break;
        case "description":
          row.minWidth = 250;
          row.renderCell = (params) => {
            return params.row.description ? params.row.description : "N/A";
          };
          break;
        case "shape":
          row.minWidth = 100;
          row.renderCell = (params) => {
            return params.row.shape ? params.row.shape : "N/A";
          };
          break;
        case "mtsTransferType":
          row.minWidth = 100;
          row.renderCell = (params) => {
            return params.row.mtsTransferType
              ? params.row.mtsTransferType
              : "internal";
          };
          break;
        case "createdAt":
          row.minWidth = 180;
          row.renderCell = (params) => {
            return params.row.createdAt;
          };
          break;
        case "acknowledgedDate":
          row.minWidth = 180;
          row.renderCell = (params) => {
            return params.row.acknowledgedDate;
          };
          break;
        case "acknowledgementStatus":
          row.minWidth = 180;
          row.renderCell = (params) => {
            return params.row.acknowledgementStatus;
          };
          break;
        case "serialNumber":
          row.minWidth = 100;
          row.renderCell = (params) => {
            return params.row.serialNumber ?? "N/A";
          };
          break;
        case "documentNumber":
        case "date":
        case "createdBy":
        case "metalOutTime":
        case "metalOutUpdatedTime":
        case "logisticName":
          row.minWidth = 200;
          break;
        default:
          row.minWidth = 100;
          break;
      }
      return row;
    });
  };

  const filterModal = () => {
    return (
      <Box className={styles.filterModal}>
        <Box className={styles.boxModalOne}>
        </Box>
        <Box className={styles.filterModalRow}>
          <Box className={styles.boxModalTwo}>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <MobileDatePicker
                slotProps={{
                  textField: { fullWidth: true, size: "small" },
                  field: {
                    InputProps: {
                      endAdornment: (
                        <IconButton>
                          <CalendarIcon />
                        </IconButton>
                      ),
                    },
                  },
                }}
                label="Start Date"
                onChange={(value) => setFromDate(value?.toString()!)}
                value={moment(
                  fromDate || (new Date().toString() as MomentInput)
                )}
              />
            </LocalizationProvider>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <MobileDatePicker
                slotProps={{
                  textField: { fullWidth: true, size: "small" },
                  field: {
                    InputProps: {
                      endAdornment: (
                        <IconButton>
                          <CalendarIcon />
                        </IconButton>
                      ),
                    },
                  },
                }}
                label="End Date"
                onChange={(value) => setToDate(value?.toString()!)}
                value={moment(toDate || (new Date().toString() as MomentInput))}
              />
            </LocalizationProvider>
          </Box>
          <Box>
            <Button
              variant="contained"
              onClick={getPvcStockInData}
              endIcon={<SearchIcon />}
              disabled={!fromDate || !toDate}
            >
              Apply Filter
            </Button>
          </Box>
        </Box>
        <Typography variant="caption" display="block" marginTop="5px">
          {'Note: Date filter will be applicable on Stock transfer created date.'}
        </Typography>
      </Box>
    );
  };

  const CustomToolbar = () => {
    return (
      <GridToolbarContainer>
        <GridToolbarExport csvOptions={{ fileName: "StockOutReport" }} />
      </GridToolbarContainer>
    );
  };

  const renderTable = () => {
    return (
      <>
        <div>
          {loading && <CircularModal thickness={4} />}
          <Box sx={{ width: "100%", height: '500px', overflow: 'auto' }}>
            <DataGridContainer>
              <ReportsTable
                className="payrollGrid"
                rows={pvcStockOutOrders || []}
                columns={getPvcStockDataColumns()}
                getRowId={(row) => row.id}
                disableRowSelectionOnClick={true}
                rowHeight={50}
                slots={{ toolbar: CustomToolbar }}
                hideFooter={true}
                fixedHeight={true}
              />
            </DataGridContainer>
          </Box>
        </div>
      </>
    );
  };

  useEffect(() => {
    getDestination()
  }, [])

  return (
    <Box className={styles.container}>
    <Title style={{ textAlign: 'left', margin: '20px 10px 10px 10px', color: '#7f7d76' }}>Stock Out Report</Title>
      {filterModal()}
      {renderTable()}
    </Box>
  );
};
